<template>
    <transition
        :css="false"
        appear
        @enter="intro"
        @leave="outro"
    >
        <section class="Chapter">
            <div
                ref="separator"
                class="Chapter-separator"
            ></div>
            <chapter-slide
                v-for="(chapter, index) in chapters"
                v-show="isInHome && chapterVisible(chapter.id)"
                :key="chapter.id"
                :index="index + 1"
                :total="chapters.length"
                :chapter="chapter"
            ></chapter-slide>
            <div ref="chapterNav" class="Chapter-nav">
                <arrow-bttn
                    class="Chapter-navBttn"
                    @click="gotoPreviousChapter()"
                    up
                    light
                    bordered
                ></arrow-bttn>
                <arrow-bttn
                    class="Chapter-navBttn"
                    @click="gotoNextChapter()"
                    light
                    bordered
                ></arrow-bttn>
            </div>
            <chapter-footer v-show="isInHome"></chapter-footer>
            <logo
                class="Chapter-logo"
                :light="isInHome"
            ></logo>
        </section>
    </transition>
</template>

<script>
    import ChapterUtils from '../mixins/ChapterUtils.js'
    import ChapterSlide from '../components/ChapterSlide'
    import ArrowBttn from '../components/ArrowBttn'
    import ChapterFooter from '../components/ChapterFooter'
    import Logo from '../components/Logo'
    import {mapGetters, mapMutations} from "vuex";
    import {BG_VISIBLE, IS_IN_HOME, RIBBON_VISIBLE} from "src/app/store/modules/background";

    export default {
        name: 'Chapter',
        mixins: [ChapterUtils],
        components: {
            ChapterSlide,
            ArrowBttn,
            ChapterFooter,
            Logo,
        },
        data() {
            return {
                carouselEase: Quart.easeIn,
            }
        },
        mounted() {
            const {activeChapterId} = this;
            if (!activeChapterId) {
                const {firstChapter} = this;
                this.updateActiveChapterId(firstChapter.id, 0)
            }
        },
        methods: {
            intro(el, done) {
                this.setRibbonVisible(true);
                this.setBgVisible(true);
                this.setIsInHome(true);
                done();
            },
            outro(el, done) {
                this.setIsInHome(false);
                this.setBgVisible(false);
                this.setRibbonVisible(false);
                done();
            },
            tweenUI(isInHome) {
                const {$refs} = this;
                TweenLite.to([$refs.separator, $refs.chapterNav], 0.5, {
                    alpha: isInHome ? 1 : 0,
                    delay: isInHome ? 0.5 : 0,
                })
            },
            chapterVisible(id) {
                const {activeChapterId} = this
                return activeChapterId === id
            },
            ...mapMutations({
                setRibbonVisible: RIBBON_VISIBLE,
                setBgVisible: BG_VISIBLE,
                setIsInHome: IS_IN_HOME
            }),
        },
        computed: {
            ...mapGetters(["isInHome"])
        },
        watch: {
            isInHome(value) {
                this.tweenUI(value)
            }
        }
    }
</script>

<style src="styles/views/Chapter.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/views/Chapter.vue